import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-faq-section',
  templateUrl: './faq-section.component.html',
  styleUrls: ['./faq-section.component.scss']
})
export class FaqSectionComponent {
  featuredFaqs = [
    {
      question: 'Wat is Kansino Nederland?',
      answer: 'Kansino Nederland is een affiliate website die de beste online casino platforms in Nederland beoordeelt en vergelijkt.'
    },
    {
      question: 'Zijn de casino platforms veilig?',
      answer: 'Wij beoordelen alleen platforms met geldige licenties en goede reputaties. We testen regelmatig de veiligheid en betrouwbaarheid.'
    },
    {
      question: 'Hoe verdient Kansino Nederland geld?',
      answer: 'Wij ontvangen een commissie wanneer u via onze links een account opent bij een casino platform. Dit heeft geen invloed op onze beoordelingen.'
    }
  ];

  expandedIndex: number | null = null;

  constructor(private router: Router) {}

  toggle(index: number): void {
    this.expandedIndex = this.expandedIndex === index ? null : index;
  }

  goToFaqPage(): void {
    this.router.navigate(['/faq']);
  }
}

